import * as yup from "yup";

export const OtherResellersSchema = yup.object().shape({
  firstName: yup.string().required().label("First Name"),
  lastName: yup.string().required().label("Last Name"),
  email: yup.string().email().required().label("Email Address"),
  phone: yup.string().required().label("Phone"),
  address1: yup.string().required().label("Address line 1"),
  address2: yup.string().required().label("Address line 2"),
});
